import { connect } from 'react-redux'
import FeedbackNav from './FeedbackNav'
import { feedbackShow } from '../../store/feedback'

const mapStateToProps = (state, ownProps) => ({
  feedback: state.feedback || { }
})

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onFeedbackNavClick: (feedbackType) => {
      dispatch(feedbackShow(feedbackType))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackNav)



// WEBPACK FOOTER //
// ./src/components/FeedbackNav/index.js